var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4794EF",
    fillRule: "evenodd",
    d: "M19.599 10a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0m-8.4-4.8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0m-2.4 3.6a1.2 1.2 0 0 0 0 2.4v3.6a1.2 1.2 0 0 0 1.2 1.2h1.2a1.2 1.2 0 0 0 0-2.4V10a1.2 1.2 0 0 0-1.2-1.2z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;